export const Logo = ({ className = "h-9 w-9" }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <rect width="64" height="64" rx="16" fill="#03045E" />
        <path
            d="M14 44V22l10 13 10-13v22"
            fill="none"
            stroke="#48CAE4"
            strokeWidth="4.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M45 27v12M39 33h12"
            stroke="#E0F7FA"
            strokeWidth="4.5"
            strokeLinecap="round"
        />
    </svg>
);
